<template>
    <div class="simulation-banner"> {{translate('Controls.text13')}}
        <router-link class="scenario-route" to="/scenarios">{{translate('Controls.text14')}}</router-link>
    </div>
</template>

<script>
    export default {
        name: "simulationBanner",
        methods: {

        }
    }
</script>

<style scoped>
    .simulation-banner{

        border: thin solid black;
        border-radius: 6px;
        padding: 1em;
        text-align: center;
        margin: 10em auto;
        background-color: #faa;

    }
    .simulation-banner a{
        color: #337ab7;
        text-decoration: underline;
    }

</style>